import { useState, useEffect } from "react";
import { useTypedSelector } from "../../../hooks/useTypedSelector";
import {
  AddressType,
  useAddToCartMutation,
  useGetAddressQuery,
  useGetCartQuery,
} from "../../../store";
import { CardMedia, Stack } from "@mui/material";
import { Login } from "./Login";
import { Address } from "./Address/Address";
import { OrderSummary } from "./OrderSummary";
import { Payment } from "./Payment/Payment";
import { useNotification } from "../../hooks";

export const SinglePageCheckout = () => {
  const notify = useNotification();
  const { isLoggedin } = useTypedSelector(s => s.auth);
  const [loginModalOpen, setLoginModalOpen] = useState(false);
  const [shippingAddress, setShippingAddress] = useState<AddressType>();
  const [billingAddress, setBillingAddress] = useState<AddressType>();
  const [shippingAndBillingSame, setShippingAndBillingSame] = useState(true);

  const { data: cartData } = useGetCartQuery(undefined, { skip: !isLoggedin });
  const { data: addressData } = useGetAddressQuery(undefined, {
    skip: !isLoggedin,
  });
  const [addToCart] = useAddToCartMutation();

  useEffect(() => {
    if (addressData && addressData.length > 0) {
      setShippingAddress(addressData[0]);
      setBillingAddress(addressData[0]);
    }
  }, [addressData]);

  useEffect(() => {
    if (shippingAndBillingSame) {
      setBillingAddress(shippingAddress);
    }
  }, [shippingAddress, billingAddress, shippingAndBillingSame]);

  useEffect(() => {
    const handleAddToCartFromLocalStorage = async () => {
      if (isLoggedin) {
        const data = localStorage.getItem("addToCartProduct");
        if (data) {
          const addToCartPayload = JSON.parse(data);
          notify(await addToCart(addToCartPayload), {
            successMessage: "Item added to cart successfully",
          });
          localStorage.removeItem("addToCartProduct");
        }
      }
    };
    handleAddToCartFromLocalStorage();
  }, [isLoggedin]);

  return (
    <Stack gap={4}>
      <CardMedia
        src="https://swiftly-files.s3.ap-south-1.amazonaws.com/coupon_code_asset_creative.jpg"
        component="img"
      />
      <Login open={loginModalOpen} setOpen={setLoginModalOpen} />
      {addressData && (
        <Address
          addressData={addressData}
          shippingAddress={shippingAddress}
          setShippingAddress={setShippingAddress}
          billingAddress={billingAddress}
          setBillingAddress={setBillingAddress}
          shippingAndBillingSame={shippingAndBillingSame}
          setShippingAndBillingSame={setShippingAndBillingSame}
        />
      )}
      {cartData && (
        <OrderSummary
          cartData={cartData}
          currency={
            shippingAddress
              ? shippingAddress.country.toLocaleLowerCase() === "india"
                ? "INR"
                : "USD"
              : undefined
          }
        />
      )}
      {shippingAddress && cartData && (
        <Payment
          cartData={cartData}
          billingAddress={shippingAddress}
          shippingAddress={shippingAddress}
        />
      )}
    </Stack>
  );
};
